import { useCallback, useState } from 'react';

// useState mirrored to sessionStorage (survives tab navigation within a session).
export function useSessionState<T>(key: string, def: T) {
  const [s, setS] = useState<T>(() => {
    try {
      const v = sessionStorage.getItem(key);
      return v !== null ? (JSON.parse(v) as T) : def;
    } catch {
      return def;
    }
  });
  const set = useCallback(
    (v: T | ((p: T) => T)) => {
      setS((p) => {
        const n = typeof v === 'function' ? (v as (p: T) => T)(p) : v;
        try {
          sessionStorage.setItem(key, JSON.stringify(n));
        } catch {
          /* ignore quota errors */
        }
        return n;
      });
    },
    [key]
  );
  return [s, set] as const;
}
